import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Pacifico\",\"arguments\":[{\"variable\":\"--font-pacifico\",\"subsets\":[\"latin\"],\"weight\":\"400\"}],\"variableName\":\"pacifico\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Reloader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
